var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tickets',{attrs:{"tickets":_vm.tickets,"alltickets":_vm.allTickets,"ticketcategories":_vm.ticketCategories,"ticketcategoryitems":_vm.ticketCategoryItems,"users":_vm.organisationUsers,"switchingcentres":_vm.switchingCentres,"locationnodes":_vm.locationNodes,"locationnetworks":_vm.locationNetworks,"locations":_vm.locations}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }